module.exports = __webpack_public_path__ + "media/images/mastercard-db9f25f1aa54186bb4585bda3457d8ae.png";